import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { OpRoute, OpFile } from '../models/core'
import { Enums } from "../models/common"
import { ColumnInfo } from "../models/custom"

export class DataProviderRoute {

    //#region Ctor

    constructor(private dataProvider: DataProvider) { }

    //#endregion


    //#region Delete

    public deleteRoute = (route: OpRoute): JQueryPromise<OpRoute> => {
        route.opState = Enums.OpChangeState.Modified

        if (route.dataList.getValue(Enums.DataType.HELPER_ID_ROUTE_STATUS) == null) {
            route.dataList.setValue(Enums.RouteStatus.CANCELLED, Enums.DataType.HELPER_ID_ROUTE_STATUS)
        }

        this.dataProvider

        return this.saveRoute(route)
    }

    //#endregion


    //#region Get

    public getRoute = (id: number): JQueryPromise<OpRoute> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetRoute', { idRoute: id }, 'OpxGetRouteResult')
            .then((response: any) => {
                if (response != null) {
                    const route: OpRoute = new OpRoute(response)

                    return OpRoute
                        .loadNavigationProperties(this.dataProvider, [route])
                        .then((routes: OpRoute[]) => {
                            return _.first(routes)
                        })
                }

                return null
            })


    }

    public getRouteFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpRoute>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdRoute, 'OpxRouteFilter', 'OpxRouteFilterResult')
    }

    //#endregion


    //#region Save

    public saveRoute = (route: OpRoute): JQueryPromise<OpRoute> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveRoute', { ToBeSaved: route.toJSON() }, 'OpxSaveRouteResult')
            .then((response: any) => {
                if (response != null) {
                    const result: OpRoute = new OpRoute(response)

                    return OpRoute
                        .loadNavigationProperties(this.dataProvider, [result])
                        .then((routes: OpRoute[]) => _.first(routes))
                }

                return null
            })
    }


    //#endregion


    //#region Files

    public getRouteFiles = (idRoute: number): JQueryPromise<OpFile[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetRouteFile', { IdRoute: idRoute }, 'OpxGetRouteFileResult')
            .then((response: any[]) => {
                if (response != null) {
                    return response.map((opObj: any) => new OpFile(opObj))
                }

                return null
            })
    }

    //#endregion
}